import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSelector, useDispatch } from "react-redux";
import { signUp } from "../../../store/User/UserAction";
import { userAction } from "../../../store/User/UserReducer";
import Loading from "../../../components/Loading";
import OTP from "../OTP";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { isValidPhoneNumber } from 'libphonenumber-js';

const SignUp = () => {
    const [name, setName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [email, setEmail] = useState("");
    const [errorField, seterrorField] = useState("");
    const [openOTP, setOpenOTP] = useState(false);

    const dispatch = useDispatch();
    const { loading, success, error, message } = useSelector(
        (state) => state.user
    );

    useEffect(() => {
        if (success) {
            setOpenOTP(true);
            dispatch(userAction.clearSuccess());
            toast.success(message, {
                position: "top-right",
                bodyStyle: { fontSize: "16px" },
            });
        }

        if (error) {
            setOpenOTP(false);
            dispatch(userAction.clearError());
            toast.error(message, {
                position: "top-right",
                bodyStyle: { fontSize: "16px" },
            });
        }
    }, [success, error, dispatch, message]);

    const formatToE164 = (number) => {
        if (number.startsWith('+')) return number;
        if (/^\d{10,15}$/.test(number)) return '+' + number;
        return number;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formattedNumber = formatToE164(mobileNumber);

        if (!name || !mobileNumber || !email) {
            seterrorField("Name, mobile number, and email are required.");
        } else if (!isValidPhoneNumber(formattedNumber)) {
            seterrorField("Please enter a valid phone number.");
        } else {
            seterrorField("");
            dispatch(signUp({ name, mobile: mobileNumber, email }));
        }
    };


    return (
        <div className="signUp">
            {loading ? (
                <Loading />
            ) : !openOTP ? (
                <div className="signUp__wrapper">
                    <div className="signUp__header">
                        <div className="signUp__logo">
                            <svg className="signUp__icon" aria-hidden="true" role="img">
                                <use href="/sprite.svg#icon-Margin"></use>
                            </svg>
                        </div>
                        <div className="signUp__title">
                            <div className="signUp__main-title">New here?</div>
                            <div className="signUp__sub-title">Let’s stamp your first travel story!</div>
                        </div>
                    </div>
                    <form className="signUp__form" onSubmit={handleSubmit}>
                        <label className="signUp__label">Enter Your Phone</label>
                        <PhoneInput
                            country={"in"}
                            value={mobileNumber}
                            onChange={(phone) => setMobileNumber(phone)}
                            inputClass="signUp__input"
                            buttonClass="signUp__country-select"
                            dropdownClass="signUp__dropdown"
                        />

                        <div className="signUp__email-container">
                            <label className="signUp__label">Enter Your Email</label>
                            <input
                                type="email"
                                value={email}
                                className="signUp__input"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="signUp__name-container">
                            <label className="signUp__label">Enter Your Name</label>
                            <input
                                type="text"
                                value={name}
                                className="signUp__input"
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>

                        {errorField && (
                            <div className="signUp__errorField">{errorField}</div>
                        )}

                        <button type="submit" className="signUp__button">
                            Continue
                        </button>

                        <div className="signUp__footer">
                            Already have an account?{" "}
                            <Link to="/signIn" className="signUp__link">Sign In</Link>
                        </div>
                    </form>
                </div>
            ) : (
                <OTP mobile={mobileNumber} setOpenOTP={setOpenOTP} page={"signUp"} />
            )}
        </div>
    );
};

export default SignUp;